import { render, staticRenderFns } from "./AddTimeslotDialog.vue?vue&type=template&id=6a1a151a&scoped=true&"
import script from "@/views/RosterTemplates/AddTimeslotDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterTemplates/AddTimeslotDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterTemplates/add-timeslot-dialog.scss?vue&type=style&index=0&id=6a1a151a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a151a",
  null
  
)

export default component.exports